export default __webpack_public_path__ + "1a5f1fc8f46345460100c23f25ef31d7.png";